// 後端回應非 0 錯誤碼的例外型別。
// Unity 端由 BaseGameService 在收到 ResponseInfo.Code != 0 的當下直接呼叫 ShowErrorCode(code)；
// 本專案的 transport 層不碰 UI（見 CLAUDE.md「移植時要修正的來源反模式」：BaseGameService 混雜
// transport／流程／UI 副作用），故改為帶著 code 往上拋，由遊戲層決定要不要顯示對話框。

export class ServerError extends Error {
  /** 後端 ResponseInfo.Code（對應 Dialog 表的 Error_Code_{code}）。 */
  readonly code: number

  constructor(code: number, message: string) {
    super(`伺服器回應錯誤 code=${code}${message.length > 0 ? ` ${message}` : ''}`)
    this.name = 'ServerError'
    this.code = code
  }
}

/** 型別守衛：判斷例外是否為帶錯誤碼的後端錯誤。 */
export function isServerError(error: unknown): error is ServerError {
  return error instanceof ServerError
}
